// ============================================================
//  UTILS
// ============================================================

import type { DateInfo } from '../types';

const DAYS   = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
const DAYS_S = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export function generateId(): string {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 7);
}

export function getDateInfo(date?: Date | null): DateInfo {
  const d = date || new Date();
  return {
    dayFull:  DAYS[d.getDay()],
    dayShort: DAYS_S[d.getDay()],
    dateStr:  `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`,
    shortStr: `${DAYS_S[d.getDay()]} ${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`,
    iso:      d.toISOString().split('T')[0],
  };
}

export function formatTime(isoStr?: string | null): string {
  if (!isoStr) return '';
  return new Date(isoStr).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
}

export function formatWorkDate(dateInputVal: string): string {
  const d = new Date(dateInputVal + 'T00:00:00');
  return `${DAYS_S[d.getDay()]} ${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function escHtml(str?: string | null): string {
  if (!str) return '';
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function workDateToISO(workDate: string): string | null {
  try {
    const parts = workDate.split(' ');
    const day   = parseInt(parts[1], 10);
    const month = MONTHS.indexOf(parts[2]);
    const year  = parseInt(parts[3], 10);
    if (month === -1) return null;
    return `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  } catch {
    return null;
  }
}

export function fmt12Hour(time24: string): string | null {
  if (!time24) return null;
  const [h, m] = time24.split(':');
  const hour   = parseInt(h, 10);
  const ampm   = hour >= 12 ? 'PM' : 'AM';
  return `${hour % 12 || 12}:${m} ${ampm}`;
}
